// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"jZ","sticky_header_title":"kZ","stycky_header_title_mob":"lZ","root_scroller":"mZ","scroller":"nZ","indicator":"oZ","scrollButtons":"pZ","selected":"qZ","root_tab_scrollable":"rZ","root_scroller_mob":"sZ","scroller_mob":"tZ","indicator_mob":"uZ","selected_mob":"vZ","root_tab_mob":"wZ","root_tab_mob_scrollable":"xZ","sticky_header_title_mob":"yZ"};
    if(module.hot) {
      // 1714654898445
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  